import { BUYER_AVAILABILITY_CONFIRMED_BADGE_LABEL } from "@/lib/items/sellerAvailabilityConfirmed";

type ConfirmedAvailableBadgeProps = {
  compact?: boolean;
  className?: string;
};

export default function ConfirmedAvailableBadge({
  compact = false,
  className = "",
}: ConfirmedAvailableBadgeProps) {
  const badgeClass = compact
    ? "bg-emerald-600 text-white text-[10px] font-medium px-1.5 py-0.5 rounded-md leading-tight"
    : "bg-emerald-600 text-white text-xs font-medium px-2 py-1 rounded-md";

  return (
    <span
      className={`${badgeClass} ${className}`.trim()}
      aria-label={BUYER_AVAILABILITY_CONFIRMED_BADGE_LABEL}
    >
      {BUYER_AVAILABILITY_CONFIRMED_BADGE_LABEL}
    </span>
  );
}
